import React, { useState, useEffect } from "react";
import "./DepartmentForm.css";
// import { Form,Button } from "react-bootstrap";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";

function DepartmentForm(props) {
  const [companyInfo, setCompanyInfo] = useState([]);
  const [headsData, setHeadsData] = useState([]);

  const loadCompanyInfo = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/company", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then((response) => {
        setCompanyInfo(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const loadHeadsInfo = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/headsofDepts", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then((response) => {
        setHeadsData(response.data);
        setCompanyInfo(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    loadCompanyInfo();
    loadHeadsInfo();
  }, []);

  return (
    <div>
      <h2 id="role-form-title">Add Department Details</h2>

      <div id="role-form-outer-div">
        <Form id="form" onSubmit={props.onDepartmentSubmit}>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Company
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="country" required>
                <option value="" disabled selected>
                  Select your option
                </option>
                {companyInfo.map((data, index) => (
                  <option value={data["_id"]}>{data["CompanyName"]}</option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              HOD
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="country">
                <option value="" disabled selected>
                  Select Head of Department
                </option>
                {headsData.map((data, index) => (
                  <option key={index} value={data["_id"]}>
                    {data["FirstName"] + "-" + data["LastName"]}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Department
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="Text"
                placeholder="Department"
                name="Department"
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button type="submit">Submit</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}

export default DepartmentForm;
